// FILE is intentionally absent: uploads authorize on their parent entity's
// module, so a second gate would conflict.
export const PRODUCT_MODULE_LIST = [
    "CLIMATE_ACTION",
    "PROJECT",
    "TASK",
    "MILESTONE",
    "INDICATOR",
    "INVENTORY",
    "SCENARIO",
    "REDUCTION_PLAN",
    "FOCUS_AREA",
    "DATA_REQUEST",
    "MUNICIPAL_PROPERTY",
    "DASHBOARD",
    "FUNDING",
    "LABEL",
    "CUSTOM_FIELD",
    "STORED_VIEW",
    "WORKSPACE_CONFIG",
    "TEAM",
    "WORKSPACE_MEMBER",
    "WORKSPACE_SETTING",
    "ACTIVITY_LOG",
];
